import _pt from "prop-types";
import * as React from 'react';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { PkpassNumberStyleTypes } from '../../../../../../../types';
import { usePkpass } from '../../../../usePkpass';

const getStyle = style => {
  switch (style) {
    case PkpassNumberStyleTypes.PKNumberStylePercent:
      return 'percent';

    case PkpassNumberStyleTypes.PKNumberStyleDecimal:
    default:
      return 'decimal';
  }
};

export default function FieldPreviewNumber(props) {
  const {
    language
  } = usePkpass();
  const {
    value,
    style
  } = props;

  if (style === PkpassNumberStyleTypes.PKNumberStyleSpellOut) {
    return /*#__PURE__*/React.createElement("span", null);
  }

  if (style === PkpassNumberStyleTypes.PKNumberStyleScientific) {
    return /*#__PURE__*/React.createElement("span", null, Number(value).toExponential().replace(/\+/g, '').toUpperCase());
  }

  const options = {
    style: getStyle(style),
    value: Number(value)
  };
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: language
  }, /*#__PURE__*/React.createElement(FormattedNumber, options));
}
FieldPreviewNumber.propTypes = {
  value: _pt.oneOfType([_pt.string, _pt.number]).isRequired
};
//# sourceMappingURL=FieldPreviewValueNumber.js.map